<script setup>
import { useDetailsReport } from '#/detailsReport/useDetailsReport'
import { inject, computed } from 'vue'
import PotentialScoreChart from '#/detailsReport/PotentialScoreChart'
import TotalScorePopup from '#/detailsReport/TotalScorePopup'
const { potential, version, mapStyle } = useDetailsReport()
const { application, pages, screen, global } = inject('Shared')

const splitAddress = computed(() => {
  const address = potential.value.buildings[0].address
  const index = address.match(/\d{4}/).index - 1
  return [address.slice(0, index - 1), address.slice(index + 1)]
})

const SelectedBackgroundColor = computed(() => {
  if (application === 'WIDGET') {
    return pages.value.detailReport.mapboxViewBtnSelectedBackgroundColor
  }
  return '#1F47CD'
})
const SelectedColor = computed(() => {
  if (application === 'WIDGET') {
    return pages.value.detailReport.mapboxViewBtnSelectedColor
  }
  return '#DCE7F2'
})
const UnselectedBackgroundColor = computed(() => {
  if (application === 'WIDGET') {
    return pages.value.detailReport.mapboxViewBtnUnselectedBackgroundColor
  }
  return '#DCE7F2'
})
const UnselectedColor = computed(() => {
  if (application === 'WIDGET') {
    return pages.value.detailReport.mapboxViewBtnUnselectedColor
  }
  return '#1F47CD'
})
</script>

<template lang="pug">
.potential-map--container
  #potentialPageMap(:style="`height: 490px; width: 100%;`").box
    .scoreBox
      potential-score-chart(:data="potential.analysis.score" height="137px" width="100%").gt-sm
        .scores
          .currentScore {{potential.analysis.score}}
          .totalScore /100
      .scoreRow
        .score-text--container
          .scoreText Total-Score
          total-score-popup.lt-md(:offset="[-200, -350]" content-width="250px")
        .scores.lt-md
          .currentScore {{potential.analysis.score}}
          .totalScore /100
        total-score-popup.gt-sm(:offset="[-400, -100]" content-width="250px")
    .addressPopupBox
      .addressBox
        .addressLabel {{application === 'WEB_APP' ? 'Raumpioniere-' : ''}}Potenzialanalyse
        .addressRow
          .svg(style="width: 36px" v-if="application === 'WEB_APP' && version === 1")
            svg(width='36' height='35' viewBox='0 0 36 35' fill='none' xmlns='http://www.w3.org/2000/svg')
              path(d='M17.1156 0.676341C17.4908 -0.0348052 18.5092 -0.0348076 18.8844 0.676339L23.8835 10.1513C24.0282 10.4256 24.2919 10.6172 24.5975 10.6701L35.1535 12.4965C35.9458 12.6336 36.2605 13.6022 35.7001 14.1788L28.2337 21.8612C28.0176 22.0835 27.9168 22.3936 27.961 22.7005L29.4859 33.3043C29.6004 34.1002 28.7764 34.6988 28.0548 34.344L18.4412 29.617C18.163 29.4801 17.837 29.4801 17.5588 29.617L7.94516 34.344C7.22361 34.6988 6.39964 34.1002 6.51409 33.3043L8.03902 22.7005C8.08316 22.3936 7.98242 22.0835 7.76631 21.8612L0.299856 14.1788C-0.26054 13.6022 0.0541873 12.6336 0.846473 12.4965L11.4025 10.6701C11.7081 10.6172 11.9718 10.4256 12.1165 10.1513L17.1156 0.676341Z' fill='#5FEFC0')
          .address
            div {{ splitAddress[0] }}
            div {{ splitAddress[1] }}
    .mapStyleContainer
      .mapStyleButton(:class="mapStyle === 'LIGHT' ? 'leftButtonSelected' : 'leftButtonUnSelected'" @click="mapStyle = 'LIGHT'") Map
      .mapStyleButton(:class="mapStyle === 'SATELLITE' ? 'rightButtonSelected' : 'rightButtonUnSelected'" @click="mapStyle = 'SATELLITE'") Satellit
</template>

<style lang="sass">
.methodContainer
  display: flex
  justify-content: center
  align-items: center
.potential-map--container
  width: 100%
  @media screen and (min-width: 1024px)
    margin-bottom: 30px
  @media screen and (max-width: 1023px)
    margin-bottom: 20px
  .leftButtonSelected
    background: v-bind(SelectedBackgroundColor)
    color: v-bind(SelectedColor)
    @media screen and (min-width: 1024px)
      border-top-left-radius: v-bind('global.buttonBorderRadius')
      border-bottom-left-radius: v-bind('global.buttonBorderRadius')
  .leftButtonUnSelected
    background: v-bind(UnselectedBackgroundColor)
    color: v-bind(UnselectedColor)
    border-color: v-bind(UnselectedColor)
    border-style: solid
    border-width: 1px
    box-sizing: border-box
    box-shadow: 0px 6px 16px rgba(0, 123, 255, 0.12)
    @media screen and (min-width: 1024px)
      border-top-left-radius: v-bind('global.buttonBorderRadius')
      border-bottom-left-radius: v-bind('global.buttonBorderRadius')
  .rightButtonSelected
    background: v-bind(SelectedBackgroundColor)
    color: v-bind(SelectedColor)
    box-sizing: border-box
    box-shadow: 0px 6px 16px rgba(0, 123, 255, 0.12)
    @media screen and (min-width: 1024px)
      border-top-right-radius: v-bind('global.buttonBorderRadius')
      border-bottom-right-radius: v-bind('global.buttonBorderRadius')
  .rightButtonUnSelected
    background: v-bind(UnselectedBackgroundColor)
    color: v-bind(UnselectedColor)
    border-color: v-bind(UnselectedColor)
    border-style: solid
    border-width: 1px
    box-sizing: border-box
    box-shadow: 0px 6px 16px rgba(0, 123, 255, 0.12)
    @media screen and (min-width: 1024px)
      border-top-right-radius: v-bind('global.buttonBorderRadius')
      border-bottom-right-radius: v-bind('global.buttonBorderRadius')
  .scoreBox
    position: absolute
    z-index: 3
    border: 1px solid #D9D9D9
    border-radius: 10px
    @media screen and (min-width: 1024px)
      right: 20px
      top: 20px
      padding: 20px
      background: rgba(255, 255, 255, 0.9)
    @media screen and (max-width: 1023px)
      right: 10px
      bottom: 10px
      width: 122px
      height: 87px
      padding: 7px 7px 7px 14px
      background: white
  .scores
    @media screen and (min-width: 1024px)
      position: absolute
      top: 40px
      width: 100%
      text-align: center
    @media screen and (max-width: 1023px)
      display: flex
      flex-direction: row
      align-items: center
    .currentScore
      font-weight: 700
      font-size: 48px
      color: #007BFF
      @media screen and (min-width: 1024px)
        line-height: 59px
      @media screen and (max-width: 1023px)
        line-height: 48px
    .totalScore
      font-weight: 500
      font-size: 16px
      line-height: 16px
      margin-top: -5px
      text-align: center
      color: #626C85
      align-self: flex-end
  .scoreRow
    @media screen and (min-width: 1024px)
      display: flex
      flex-direction: row
      align-items: center
    @media screen and (max-width: 1023px)
    .score-tooltip--content
      ul
        padding: 0 0 0 30px !important
    .score-text--container
      display: flex
      align-items: center
      flex-direction: row
      margin-top: 3px
      .scoreText
        color: #22223C
        font-weight: 700
        @media screen and (min-width: 1024px)
          margin-right: 5px
          font-size: 20px
          line-height: 24px
        @media screen and (max-width: 1023px)
          margin-right: 5px
          font-size: 12px
          line-height: 154%
          color: #626C85

  .addressPopupBox
    position: absolute
    z-index: 2
    width: 377px
    min-height: 126px
    border: 1px solid #D9D9D9
    border-radius: 10px
    background: rgba(255, 255, 255, 0.9)
    @media screen and (min-width: 1024px)
      left: 20px
      top: 20px
    @media screen and (max-width: 1023px)
      max-width: calc(100% - 20px)
      left: 10px
      top: 10px
    .addressBox
      border-radius: 10px
      box-sizing: border-box
      padding: 16px 20px
      width: 100%
      height: 100%
      .addressRow
        margin-top: 5px
        display: flex
        flex-direction: row
        align-content: center
      .address
        font-style: normal
        font-weight: bold
        font-size: v-bind('pages.detailReport.addressFontSize')
        line-height: 130%
        color: v-bind('pages.detailReport.addressColor')
        flex: 1
      .svg
        margin-right: 10px
      .addressLabel
        font-style: normal
        font-weight: bold
        font-size: 15px
        line-height: 154%
        color: #626C85
  .box
    position: relative
    background: rgba(255, 255, 255, 0.9)
    border: 1px solid #D9D9D9
    box-sizing: border-box
    box-shadow: 0px 15px 30px rgba(166, 166, 166, 0.25)
    border-radius: 10px
    @media screen and (min-width: 1024px)
      padding: 30px 40px
      height: 470px
    @media screen and (max-width: 1023px)
      padding: 15px 20px 15px 20px
    .mapStyleContainer
      position: absolute
      z-index: 2
      display: flex
      @media screen and (min-width: 1024px)
        bottom: 30px
        left: 20px
        flex-direction: row
      @media screen and (max-width: 1023px) and (min-width: 400px)
        bottom: 35px
        left: 10px
        flex-direction: row
      @media screen and (max-width: 400px)
        flex-direction: column
        bottom: 10px
        left: 10px
      .mapStyleButton
        cursor: pointer
        display: flex
        justify-content: center
        align-content: center
        width: 88px
        padding: 5px 0
        font-size: 14px
        font-weight: bold
        line-height: 130%
</style>
